var map = {
	"./svg/circle/add.svg": 52682,
	"./svg/circle/delete.svg": 63374,
	"./svg/external_link.svg": 2145,
	"./svg/logo_white.svg": 80345,
	"./svg/logo_with_text.svg": 1498,
	"./svg/logo_with_text_white.svg": 98865,
	"./svg/money.svg": 24227,
	"./svg/people.svg": 40672,
	"./svg/price.svg": 2708,
	"./svg/ruble.svg": 15102,
	"./svg/student_hat.svg": 82791,
	"./svg/table_pencil.svg": 5682,
	"./web/android-chrome-192x192.png": 16812,
	"./web/android-chrome-512x512.png": 3229,
	"./web/apple-touch-icon.png": 71830,
	"./web/content/employees-no_photo_index.png": 63417,
	"./web/content/employees-no_photo_show.png": 91281,
	"./web/en_logo_white.svg": 68578,
	"./web/favicon-16x16.png": 93602,
	"./web/favicon-32x32.png": 73522,
	"./web/favicon.ico": 53941,
	"./web/files_icons/doc.svg": 4628,
	"./web/files_icons/folder.png": 59306,
	"./web/files_icons/pdf.svg": 68563,
	"./web/files_icons/ppt.svg": 50686,
	"./web/files_icons/txt .svg": 62863,
	"./web/files_icons/unknown.svg": 21717,
	"./web/files_icons/xls.svg": 34066,
	"./web/footer_bg.jpg": 94318,
	"./web/fr_logo_white.svg": 29192,
	"./web/icon/en.svg": 85616,
	"./web/icon/fr.svg": 10940,
	"./web/icon/lowVisible.svg": 17569,
	"./web/icon/ru.svg": 11224,
	"./web/icon/zh-CN.svg": 31640,
	"./web/logo.svg": 25433,
	"./web/logo_footer2.png": 58217,
	"./web/logo_white.svg": 52050,
	"./web/logo_with_text.svg": 13085,
	"./web/mstile-150x150.png": 48518,
	"./web/news__bg.png": 8501,
	"./web/priem_card_footer.png": 78885,
	"./web/priem_header.png": 7959,
	"./web/priem_heart.png": 16214,
	"./web/safari-pinned-tab.svg": 965,
	"./web/social_networks/facebook.svg": 96194,
	"./web/social_networks/instagram.svg": 99168,
	"./web/social_networks/telegram.svg": 63518,
	"./web/social_networks/twitter.svg": 3588,
	"./web/social_networks/vk.svg": 49538,
	"./web/social_networks/whatsapp.svg": 88091,
	"./web/social_networks/youtube.svg": 94221,
	"./web/ul_li.png": 40212
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27325;